import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { IMaskInput } from 'react-imask';

const InputContainer = styled.div`
    display: flex;
    justify-content: center;

    & > div {
        max-width: 360px;
    }
  
    input::placeholder {
        color: #CCCCCC;
    }
  
    #deterministic-outlined-input:focus {
      border: 2px solid #2d5dec !important;
    }
`;

const Weight = (props) => {
    const {
        question,
        containerClassName = "carat-weight-container",
        placeholder = "0.0 ct.",
        onChange,
    } = props;

    return (
        <div className={containerClassName}>
            <span className={"question"}>{question.q}</span>
            <InputContainer className="deterministic-outlined-input">
                    <IMaskInput
                        id="deterministic-outlined-input"
                        mask={Number}
                        scal={2}
                        radix={'.'}
                        autofix={true}
                        min={0.1}
                        max={30.0}
                        mapToRadix={[',']}
                        onAccept={onChange}
                        placeholder={placeholder}
                        inputMode='decimal'
                        type='string'
                        style={{
                            height: '54px',
                            padding: '16px 24px',
                            borderRadius: '4px',
                            border: '1px solid #2d5dec',
                            boxSizing: 'border-box',
                            fontSize: '16px',
                            fontWeight: 400,
                            fontFamily: 'Roboto,serif',
                        }}
                    />
            </InputContainer>
        </div>
    );
};

Weight.propTypes = {
    question: PropTypes.shape({
        answers: PropTypes.arrayOf(PropTypes.string),
        other: PropTypes.bool,
        q: PropTypes.string,
        key: PropTypes.string,
    }),
    onChange: PropTypes.func,
    value: PropTypes.string,
    containerClassName: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
};

export default Weight;
